import React from "react";
import { themeVariables } from "../../themes/constants";
import Box from "./Box";

interface IProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  horizontal?: boolean;
  style?: React.CSSProperties;
  backgroundColor?: string;
}

const WhiteSpace = (props: IProps) => {
  const { size = "md", horizontal = false, style, backgroundColor } = props;
  return (
    <Box
      style={{
        ...(horizontal
          ? { width: (themeVariables as any)[`spacing_${size}`] }
          : {
              height: (themeVariables as any)[`spacing_${size}`],
            }),
        ...style,
      }}
      backgroundColor={backgroundColor}
    />
  );
};

export default WhiteSpace;
